import { Typography } from "@mui/material";
import Dialog from "../../Common/Dailog/Dailog";
import FullScreenLoader from "../../Common/ScreenLoader/FullScreenLoader";

const DeleteTemplateDialog = ({
  open,
  template,
  loading = false,
  onClose,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    title="Delete Template"
    maxWidth="xs"
    fullWidth
    showCloseButton
    actions={[
      { label: "Cancel", variant: "ghost", onClick: onClose, disabled: loading },
      {
        label: "Delete",
        variant: "primary",
        onClick: onConfirm,
        disabled: loading,
      },
    ]}
  >
    {loading && <FullScreenLoader message="Deleting template..." />}
    <Typography variant="body2">
      {`Are you sure you want to delete the template "${template?.templateName || ""}"?`}
    </Typography>
  </Dialog>
);

export default DeleteTemplateDialog;
